import React, { PureComponent } from 'react';

class CabeceraAsientoContable extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            comboAccionMasiva,
            checkTodosAsientosContables,
            cambiarCheckAsientosContables
        } = this.props

        let checkGeneral 
        comboAccionMasiva == "0" ? checkGeneral = false : checkGeneral = checkTodosAsientosContables;
        let deshabilitarCheck = comboAccionMasiva == "0" ? true : false

        

        return (
            <div className="seccionRenglonesModelo__cabeceraRenglonModelo">
                <div className="seccionRenglonesModelo__contenedorCabeceras AsientosContables__seccionGrillaContenedorCheckbox">
                    <div className="Tarjetas-contenedorCheckboxActivo default-checkbox Tarjetas-default-checkbox">
                        <input id={"checkTodosAsientosContables"} type="checkbox" disabled={deshabilitarCheck} checked={checkGeneral} onChange={() => cambiarCheckAsientosContables("checkTodosAsientosContables",!checkGeneral)}/>
                        <label className={"label-primary Tarjetas-checkboxLabel" + (checkGeneral ? " Tarjetas-checkboxLabel--checked" : "")} htmlFor={"checkTodosAsientosContables"}></label>
                    </div>
                </div>

                <div className="seccionRenglonesModelo__contenedorCabeceras AsientosContables__seccionGrillaContenedorFechaValor">
                    FECHA VALOR
                </div>

                <div className="seccionRenglonesModelo__contenedorCabeceras AsientosContables__seccionGrillaContenedorFechaContabilizacion">
                    FECHA CONTABILIZACIÓN
                </div>

                <div className="seccionRenglonesModelo__contenedorCabeceras AsientosContables__seccionGrillaContenedorModelo">
                    MODELO
                </div>

                <div className="seccionRenglonesModelo__contenedorCabeceras AsientosContables__seccionGrillaContenedorMarca">
                    MARCA
                </div>

                <div className="seccionRenglonesModelo__contenedorCabeceras AsientosContables__seccionGrillaContenedorMoneda">
                    MONEDA
                </div>

                <div className="seccionRenglonesModelo__contenedorCabeceras AsientosContables__seccionGrillaContenedorTotalDebito">
                    TOTAL DÉBITO
                </div>

                <div className="seccionRenglonesModelo__contenedorCabeceras AsientosContables__seccionGrillaContenedorTotalCredito">
                    TOTAL CRÉDITO
                </div>

                <div className="seccionRenglonesModelo__contenedorCabeceras AsientosContables__seccionGrillaContenedorEstado">
                    ESTADO
                </div>

                <div className="seccionRenglonesModelo__contenedorCabeceras AsientosContables__seccionGrillaContenedorFlechaDesplegable">
                </div>
            </div>
        )
    }
}

export default CabeceraAsientoContable;